export const ReviewTypeMap = {
    Reject: 0,
    Pass: 1,
};
